import util from '../util'

let controller = 'LimiteAdicional'

export default Object.assign({}, util.GetCrud(controller, ['post', 'put', 'get', 'getall', 'persist']), {
  HistoricoLimiteAdicional: function (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller + '/LogsLimiteAdicional', dto)
  }
})
